var _a;
import * as React from 'react';
import { Layout, Card, Cell, Text, Divider, Box } from 'wix-style-react';
import { translate } from 'react-i18next';
import { frequencyTranslations } from '../../RecurringPayView/RecurringPayView';
export var UNTIL_CANCELED_OPTION = 0;
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["DAILY"] = "DAILY";
    BillingCycle["WEEKLY"] = "WEEKLY";
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["FORTNIGHTLY"] = "FORTNIGHTLY";
})(BillingCycle || (BillingCycle = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["AUTOMATIC"] = "automatic";
})(PaymentType || (PaymentType = {}));
var paymentTypeKeys = (_a = {},
    _a[PaymentType.AUTOMATIC] = 'recurring-details.payment-type.auto',
    _a);
var RecurringDetailsCard = function (_a) {
    var t = _a.t, paymentType = _a.paymentType, billingCycle = _a.billingCycle, recurringPayment = _a.recurringPayment, totalRecurringPayments = _a.totalRecurringPayments;
    return (React.createElement(Card, null,
        React.createElement(Box, { maxHeight: '54px', verticalAlign: 'middle', dataHook: "recurring-details-card" },
            React.createElement(Card.Content, null,
                React.createElement(Box, { marginTop: '6px' },
                    React.createElement(Layout, { gap: '0px', justifyItems: 'left' },
                        React.createElement(Cell, { span: 3 },
                            React.createElement(Box, { direction: "horizontal" },
                                React.createElement(Box, { paddingRight: '24px' },
                                    React.createElement(Text, { secondary: true, size: 'small', weight: 'thin', dataHook: "payment-type-title" },
                                        React.createElement(Box, { whiteSpace: "pre" }, t('recurring-details.payment-type.title'))),
                                    React.createElement(Text, { secondary: true, size: 'small', weight: 'normal', dataHook: 'payment-type' }, t(paymentTypeKeys[paymentType]))),
                                React.createElement(Divider, { direction: 'vertical' }))),
                        React.createElement(Cell, { span: 3 },
                            React.createElement(Box, { direction: "horizontal", paddingLeft: '24px' },
                                React.createElement(Text, { secondary: true, size: 'small', weight: 'thin', dataHook: "billing-cycle-title" },
                                    React.createElement(Box, { whiteSpace: "pre" }, t('recurring-details.billing-cycle.title'))),
                                React.createElement(Text, { secondary: true, size: 'small', weight: 'normal', dataHook: 'billing-cycle' }, t(frequencyTranslations[billingCycle.toLowerCase()])))),
                        React.createElement(Cell, { span: 6 },
                            React.createElement(Box, { direction: "horizontal" },
                                React.createElement(Box, { paddingRight: '24px' },
                                    React.createElement(Divider, { direction: 'vertical' })),
                                React.createElement(Text, { secondary: true, size: 'small', weight: 'thin', dataHook: "recurring-payment-title" },
                                    React.createElement(Box, { whiteSpace: "pre" }, t('recurring-details.recurring-payment.title'))),
                                React.createElement(Text, { secondary: true, size: 'small', weight: 'normal', dataHook: 'recurring-payment' }, totalRecurringPayments === UNTIL_CANCELED_OPTION
                                    ? t('recurring-details.recurring-payment.unlimited')
                                    : t('recurring-details.recurring-payment.value', {
                                        recurringPayment: recurringPayment,
                                        totalRecurringPayments: totalRecurringPayments,
                                    }))))))))));
};
export default translate(['invoice-view', 'locale-data'], { wait: true })(RecurringDetailsCard);
//# sourceMappingURL=RecurringDetailsCard.js.map